import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faShieldHalved, 
  faTriangleExclamation, 
  faCheckCircle,
  faExclamationCircle 
} from '@fortawesome/free-solid-svg-icons';
import styles from './SystemBannerAndModal.module.css';
import SystemModal from './SystemModal';
import { getColors } from '../utils/systemUtils';

const SystemBanner = ({ show, data, type, onBannerClick }) => {
  const [showModal, setShowModal] = useState(false);

  if (!show || !data || !type) return null;

  const getIcon = (type) => {
    switch (type) {
      case 'security':
        return faShieldHalved;
      case 'outage':
      case 'alarm-alert-outage':
        return faTriangleExclamation;
      case 'resolved-outage':
        return faCheckCircle;
      case 'critical-recall':
      case 'non-critical-recall':
        return faExclamationCircle;
      default:
        return faTriangleExclamation;
    }
  };


  const getTitle = () => {
    if (data.title) return data.title;
    
    switch (type) {
      case 'security':
        return 'Security Alert';
      case 'outage':
        return 'System Downtime';
      case 'resolved-outage':
        return 'System Downtime - RESOLVED';
      case 'alarm-alert-outage':
        return 'Alarm & Alert Service Outage';
      case 'critical-recall':
        return 'Device Recall - Patient Safety Alert';
      case 'non-critical-recall':
        return 'Device Update - Recommended';
      default:
        return 'System Notification';
    }
  };

  const getSubtitle = () => {
    if (data.incidentId) return `Incident ID: ${data.incidentId}`;
    if (data.recallId) return `Recall ID: ${data.recallId}`;
    if (data.description) return data.description;
    return '';
  };

  const { background, color, border } = getColors(type);

  const handleBannerClick = () => {
    setShowModal(true);
    if (onBannerClick) {
      onBannerClick(type);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <div 
        className={styles.webBanner} 
        onClick={handleBannerClick} 
        style={{ backgroundColor: background, color: color, border: `0.5px solid ${border}` }}
      >
        <div className={styles.bannerContent}>
          <div className={styles.bannerIcon}>
            <FontAwesomeIcon icon={getIcon(type)} />
          </div>
          <div className={styles.bannerText}>
            <div className={styles.bannerTitle}>{getTitle()}</div>
            <div className={styles.bannerSubtitle}>
              {getSubtitle()}
            </div>
          </div>
        </div>
      </div>
      <SystemModal
        show={showModal}
        onHide={handleCloseModal}
        data={data}
        type={type}
      />
    </>
  );
};

export default SystemBanner;

